import clsx from 'clsx';
import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import { TbFileSearch, TbMapPin, TbX } from 'react-icons/tb';
import { Link } from 'react-router-dom';

import { SimpleRestaurantResponse } from '@/api/lib/restaurant';

import { Typography } from '@/components/atoms/Typography';

export interface Props {
  isSupport?: boolean;
  restaurant: SimpleRestaurantResponse;
}

export const RestaurantHomePageItem: React.FC<Props> = ({ isSupport, restaurant }: Props) => {
  const linkRoute =
    isSupport && restaurant.validationStatus === 'PENDING'
      ? `/moderation/${restaurant.id}`
      : restaurant.validationStatus === 'REJECTED'
        ? `/proposal-restaurant/${restaurant.id}`
        : restaurant.validationStatus === 'ACCEPTED'
          ? `/restaurant/${restaurant.id}`
          : `/restaurant/inactive?${restaurant.name}`;

  return (
    <Link
      to={linkRoute}
      className={clsx(
        restaurant.validationStatus === 'ACCEPTED' && 'border-gray-300 border-solid',
        restaurant.validationStatus === 'PENDING' && 'border-primary border-dashed',
        restaurant.validationStatus === 'REJECTED' && 'border-red-600 border-solid bg-red-50',
        'hover:cursor-pointer text-center w-full flex-col flex gap-2 hover:text-black hover:border-primary duration-200 md:w-52 justify-center ease-in-out p-2 border rounded-lg hover:bg-gray-100 items-center text-black'
      )}
    >
      <div className="flex gap-3 font-semibold">{restaurant.name}</div>
      {restaurant.cityName && (
        <div className="flex gap-1 items-center text-sm text-gray-500">
          <TbMapPin className="min-w-5 min-h-5" />
          {restaurant.cityName}
        </div>
      )}

      {restaurant.validationStatus === 'PENDING' && (
        <div className="flex gap-2">
          <FaSpinner className="text-primary animate-spin ring-[1px] rounded-full min-w-4 min-h-4 p-0.5 ring-primary" />
          <Typography variant="extraSmall" color="primary">
            En cours de validation
          </Typography>
        </div>
      )}

      {restaurant.validationStatus === 'REJECTED' && (
        <div className="flex gap-1 animate-pulse ring-[1px] rounded-full px-2 py-0.5 items-center bg-red-400/30 ring-red-500">
          <TbX className="text-red-800" />
          <Typography variant="extraSmall" customColorClass="text-red-800">
            {isSupport ? "Attente d'action du resto" : 'Une action vous attend'}
          </Typography>
        </div>
      )}
    </Link>
  );
};
